import InputPin from './InputPin.jsx';

export default InputPin;